import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m14.8 8-4.333 6H8.133L11.8 9H1.333V7H11.8L8.133 2h2.334L14.8 8Z", fill: "#000" }));
export default SvgArrowRight;
